import * as React from "react";

const ManualIcon = ({ color = "var(--border)", width, height }) => (
  <svg width={width} height={height} viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
    <g fill={color} fillRule="evenodd">
      <path
        d="M11.832 17.352a.75.75 0 0 0 .663.398h3.763a.75.75 0 0 0 .711-.514l.781-2.303-.134-3.464a1.798 1.798 0 0 0-.284-.52c-.164-.196-.3-.237-.453-.217-.024.004-.024.004-.08.008.059 0-.034.183-.121.53l-.489-.105c.114-.658.114-1.142.025-1.409-.162-.31-.623-.39-.812-.034-.111.32-.167.7-.167 1.138l-.5.01c-.04-.977-.138-1.573-.253-1.719-.018-.022-.561-.03-.563-.027-.121.167-.24.896-.317 2.1l-.5-.016V7.68c0-.547-.326-.829-.784-.8-.454.028-.805.352-.798.793l.125 4.393a.445.445 0 0 1-.842.212l-.028-.054a1.074 1.074 0 0 0-.959-.592.3.3 0 0 0-.277.412 898.257 898.257 0 0 0 1.324 3.249c.284.69.607 1.377.97 2.059z"
        stroke={color}
        strokeWidth={0.5}
      />
      <path d="M11.736.41a1.315 1.315 0 0 1 1.907 1.807L5.767 10.53l-.014.012-.012.013a1.31 1.31 0 0 1-1.843.013l-.017-.017L.385 7.056a1.31 1.31 0 0 1 0-1.855 1.31 1.31 0 0 1 1.855 0l2.547 2.546L11.736.41z" />
    </g>
  </svg>
);

export default ManualIcon;
